/*
 * cart-drawer.js — ported from orion-v3.0's src/js/includes/cart-drawer.js.
 *
 * Delegated click handlers that toggle the drawer via
 * window.ajaxCart.toggleCartDrawer (defined in ajax-cart.js):
 *
 *   .navbar__cart-link, .cart-drawer__trigger  → toggle (no arg)
 *   .cart-drawer__open                         → force open
 *   .cart-drawer__close, .cart-drawer__overlay → force close
 *
 * Differences from v3.0:
 *   - jQuery delegated listeners → native document.addEventListener
 *     with closest() matching.
 *   - Calls window.ajaxCart.toggleCartDrawer (global) instead of
 *     importing — H3.0 ships assets unbundled.
 */

(function () {
  function toggle(show) {
    if (window.ajaxCart && typeof window.ajaxCart.toggleCartDrawer === 'function') {
      window.ajaxCart.toggleCartDrawer(show);
    } else {
      // Fallback if ajax-cart.js hasn't loaded yet
      document.body.classList.toggle('cart-drawer--show', show);
    }
  }

  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    if (target.closest('.cart-drawer__close, .cart-drawer__overlay')) {
      e.stopPropagation();
      toggle(false);
      return;
    }

    if (target.closest('.cart-drawer__open')) {
      e.preventDefault();
      toggle(true);
      return;
    }

    if (target.closest('.navbar__cart-link, .cart-drawer__trigger')) {
      e.preventDefault();
      toggle();
    }
  });
})();
